// extracted by mini-css-extract-plugin
export default {"grid":"ProductItem_grid__gdpmw","img":"ProductItem_img__7CUVR","content":"ProductItem_content__oN36t","details":"ProductItem_details__0FvC-","list":"ProductItem_list__0f2iv"};